export default __webpack_public_path__ + "static/media/CNo.70-4.74b56ac0.jpg";